module.exports = __webpack_public_path__ + "img/VanBerlo_logo_dark-grey_RGB_APPLICATIONS.c3b8ffcb.png";